// src/subscreens/mechanicadmin/notifications/MechanicNotifications.jsx

import React, { useState, useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import {
  FaBell, FaTools, FaMoneyBillWave, FaStar,
  FaCheckCircle, FaExclamationTriangle, FaCalendarCheck,
  FaTrash, FaEnvelopeOpen, FaClock
} from "react-icons/fa";
import MechanicAdminLayout from "../../../layout/mechanic/MechanicMasterLayout";
import "../../../assets/css/mechanic/notification/Notification.css";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import { getEcho } from "../../../utils/echo";

/* ── Type Badge Config ── */
const typeBadgeConfig = {
  job:     { label: "Job",     bg: "#FFF8E6", color: "#FDB714" },
  payment: { label: "Payment", bg: "#E6F9EE", color: "#28a745" },
  review:  { label: "Review",  bg: "#FFF8E6", color: "#e5a512" },
  dispute: { label: "Dispute", bg: "#FFE6E6", color: "#dc3545" },
};

// ✅ FIX 1: type se icon decide karo — DB se icon nahi aata
const getTypeIcon = (type) => {
  const map = {
    job:     FaTools,
    payment: FaMoneyBillWave,
    review:  FaStar,
    dispute: FaExclamationTriangle,
  };
  return map[type] || FaBell;
};

// ✅ FIX 2: created_at ko readable format mein convert karo
const formatTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleString("en-PK", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export default function MechanicNotifications() {
  const { baseUrl, loggedInMechanic , authToken} = useContext(AppContext);
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  // ── PUSHER — is mechanic ke liye naya notification aate hi list
  //    ke upar add ho jayega, real-time ──
  useEffect(() => {
    if (!loggedInMechanic?.id) return;

    const echo = getEcho(baseUrl);
    if (!echo) return;

    const channel = echo.private(`mechanicadmin.${loggedInMechanic.id}`);

    channel.listen(".new-notification", (e) => {
      setNotifications((prev) => [e.notification, ...prev]);
    });

    return () => {
      echo.leave(`mechanicadmin.${loggedInMechanic.id}`);
    };
  }, [loggedInMechanic, baseUrl]);

  // ✅ FIX 3: isRead check — DB se status string "unread" aata hai
  const isUnread = (n) => n.status === "unread" || n.isRead === false;

  // ── Computed ──
  const unreadCount  = notifications.filter(isUnread).length;
  const jobCount     = notifications.filter(n => n.type === "job").length;
  const paymentCount = notifications.filter(n => n.type === "payment").length;
  const reviewCount  = notifications.filter(n => n.type === "review").length;
  const disputeCount = notifications.filter(n => n.type === "dispute").length;

  const statsData = [
    { icon: <FaBell />,                value: notifications.length, label: "Total",    color: "#FDB714" },
    { icon: <FaTools />,               value: jobCount,             label: "Jobs",     color: "#FDB714" },
    { icon: <FaMoneyBillWave />,       value: paymentCount,         label: "Payments", color: "#28a745" },
    { icon: <FaExclamationTriangle />, value: disputeCount,         label: "Disputes", color: "#dc3545" },
  ];

  // ── API ──
  const viewAllNotifications = () => {
    console.log("**********this is Mechanic in the maintainance page", loggedInMechanic);
    const formData = new FormData();
    formData.append("srmechanicadmin_id", loggedInMechanic.id);
    setLoading(true);
    axios 
      .post(
        `${baseUrl}/mechanic-admin/notifications/viewAllNotifications`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" , 
          Authorization: `Bearer ${authToken}` 
        } } // ✅ FIX 4: Headers→headers, formData spelling
      )
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({ icon: "error", title: "Error", text: response.data.error });
        } else {
          setNotifications(response.data.notifications);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to load notifications." });
      });
  };

  useEffect(() => {
    viewAllNotifications();
  }, []);

  // ✅ FIX 5: filter — status string se bhi check karo
  const filtered = notifications.filter(n => {
    if (filter === "all")    return true;
    if (filter === "unread") return isUnread(n);
    return n.type === filter;
  });

  // ── Handlers — ab yeh sab asal backend ko call karte hain, sirf local
  // state nahi badalte (warna refresh karte hi purani state wapas aa jati) ──
  const markAsRead = (id) => {
    axios
      .post(
        `${baseUrl}/mechanic-admin/notifications/markAsRead`,
        { id, srmechanicadmin_id: loggedInMechanic.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, isRead: true, status: "read" } : n))
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const markAllAsRead = () => {
    axios
      .post(
        `${baseUrl}/mechanic-admin/notifications/markAllAsRead`,
        { srmechanicadmin_id: loggedInMechanic.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true, status: "read" })));
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteNotification = (id) => {
    axios
      .post(
        `${baseUrl}/mechanic-admin/notifications/deleteNotification`,
        { id, srmechanicadmin_id: loggedInMechanic.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => n.id !== id));
        }
      })
      .catch((err) => console.log(err));
  };

  const clearRead = () => {
    axios
      .post(
        `${baseUrl}/mechanic-admin/notifications/clearRead`,
        { srmechanicadmin_id: loggedInMechanic.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => isUnread(n)));
        }
      })
      .catch((err) => console.log(err));
  };

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <MechanicAdminLayout>
      <div className="mn-page">

        {/* ── Page Header ── */}
        <div className="mn-page-header">
          <div className="mn-header-left">
            <h2 className="mn-page-title">Notifications</h2>
            {unreadCount > 0 && (
              <span className="mn-unread-badge">{unreadCount} Unread</span>
            )}
          </div>
          <div className="mn-header-actions">
            <button
              className="mn-action-btn mn-btn-primary"
              onClick={markAllAsRead}
              disabled={unreadCount === 0}
            >
              <FaEnvelopeOpen size={13} /> Mark All as Read
            </button>
            <button className="mn-action-btn mn-btn-outline" onClick={clearRead}>
              Clear Read
            </button>
          </div>
        </div>

        {/* ════════════════════════════════
            STAT CARDS
        ════════════════════════════════ */}
        <Row className="g-3 mb-4">
          {statsData.map((s, i) => (
            <Col key={i} xl={3} lg={3} md={6} sm={6}>
              <div className="mn-stat-card" style={{ borderLeft: `4px solid ${s.color}` }}>
                <div className="mn-stat-icon" style={{ color: s.color, background: `${s.color}18` }}>
                  {s.icon}
                </div>
                <div className="mn-stat-content">
                  <h3>{s.value}</h3>
                  <p>{s.label}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* ════════════════════════════════
            FILTER TABS
        ════════════════════════════════ */}
        <div className="mn-filter-tabs">
          {[
            { key: "all",     label: `All (${notifications.length})` },
            { key: "unread",  label: `Unread (${unreadCount})`       },
            { key: "job",     label: `Jobs (${jobCount})`            },
            { key: "payment", label: `Payments (${paymentCount})`    },
            { key: "review",  label: `Reviews (${reviewCount})`      },
            { key: "dispute", label: `Disputes (${disputeCount})`    },
          ].map(tab => (
            <button
              key={tab.key}
              className={`mn-filter-tab ${filter === tab.key ? "mn-tab-active" : ""}`}
              onClick={() => setFilter(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* ── Loading ── */}
        {loading && (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <p>Loading notifications...</p>
          </div>
        )}

        {/* ════════════════════════════════
            NOTIFICATIONS LIST
        ════════════════════════════════ */}
        {!loading && (
          <div className="mn-list">
            {filtered.length > 0 ? (
              filtered.map(notification => {
                // ✅ FIX 1: icon type se decide hoga
                const IconComponent = getTypeIcon(notification.type);
                const badge = typeBadgeConfig[notification.type] || 
                              { label: notification.type, bg: "#f0f0f0", color: "#666" }; // ✅ FIX 7: unknown type crash fix
                const unread = isUnread(notification);

                return (
                  <div
                    key={notification.id}
                    className={`mn-card ${unread ? "mn-card-unread" : ""}`}
                  >
                    {/* Icon */}
                    <div
                      className="mn-card-icon"
                      style={{ background: `${badge.color}18`, color: badge.color }}
                    >
                      <IconComponent size={20} />
                    </div>

                    {/* Content */}
                    <div className="mn-card-content">
                      <div className="mn-card-top">
                        <div className="mn-card-title-row">
                          <h5 className="mn-card-title">{notification.title}</h5>
                          <div className="mn-card-badges">
                            <span
                              className="mn-type-badge"
                              style={{ background: badge.bg, color: badge.color }}
                            >
                              {badge.label}
                            </span>
                            {unread && (
                              <span className="mn-new-badge">New</span>
                            )}
                          </div>
                        </div>

                        {/* ✅ FIX 8: DB mein description hai, message nahi */}
                        <p className="mn-card-message">
                          {notification.description || notification.message}
                        </p>

                        {/* ✅ FIX 2: created_at format karo */}
                        <span className="mn-card-time">
                          <FaClock size={10} style={{ marginRight: 4 }} />
                          {formatTime(notification.created_at || notification.time)}
                        </span>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="mn-card-actions">
                      {unread && (
                        <button
                          className="mn-icon-btn mn-btn-read"
                          title="Mark as read"
                          onClick={() => markAsRead(notification.id)}
                        >
                          <FaEnvelopeOpen size={14} />
                        </button>
                      )}
                      <button
                        className="mn-icon-btn mn-btn-delete"
                        title="Delete"
                        onClick={() => deleteNotification(notification.id)}
                      >
                        <FaTrash size={14} />
                      </button>
                    </div>

                    {/* Unread dot */}
                    {unread && <span className="mn-unread-dot" />}
                  </div>
                );
              })
            ) : (
              <div className="mn-empty">
                <FaBell style={{ fontSize: 44, color: "#ddd" }} />
                <h4>No Notifications</h4>
                <p>You're all caught up!</p>
              </div>
            )}
          </div>
        )}

      </div>
    </MechanicAdminLayout>
  );
}